import { Box } from '@n26/nxd'
import { SmallArticleCard } from './SmallArticleCard'
import { SectionWrapper } from './SectionWrapper'
import { BlogPostCard, type BlogPostCardProps } from '@components/BlogPostCard'

export type LatestSectionProps = {
  articles: BlogPostCardProps['post'][]
}

export const LatestSection = ({ articles }: LatestSectionProps) => {
  if (!articles) return null

  return (
    <SectionWrapper>
      <Box
        display='flex'
        gap='16'
        width='full'
        className='flex-col md:flex-row'
      >
        <Box className='hidden xs:block md:hidden'>
          <BlogPostCard isTitleExtended isLandscape post={articles[0]} />
        </Box>
        <Box className='block sm:hidden'>
          <Box gap='12' className='grid grid-cols-2 grid-rows-2 h-full'>
            {articles.slice(1).map((article, index) => (
              <Box key={index} className=''>
                <SmallArticleCard article={article} isPortrait />
              </Box>
            ))}
          </Box>
        </Box>
        <Box className='basis-8/12 block xs:hidden md:block'>
          <BlogPostCard isTitleExtended post={articles[0]} />
        </Box>
        <Box className=' hidden sm:block md:hidden'>
          <Box display='flex' flexDirection='row' gap='12'>
            {articles.slice(1).map((article, index) => (
              <Box key={index} className='w-1/4'>
                <SmallArticleCard article={article} isPortrait />
              </Box>
            ))}
          </Box>
        </Box>
        <Box className='basis-4/12 hidden md:block'>
          <Box display='flex' flexDirection='column' gap='12'>
            {articles.slice(1).map((article, index) => (
              <Box key={index}>
                <SmallArticleCard article={article} />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </SectionWrapper>
  )
}
